var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviewLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.333 14c-.366 0-.68-.13-.941-.392A1.284 1.284 0 0 1 2 12.667V3.333c0-.366.13-.68.392-.941.26-.261.575-.392.941-.392h9.334c.366 0 .68.13.941.392.261.26.392.575.392.941v9.334c0 .366-.13.68-.392.941a1.284 1.284 0 0 1-.941.392H3.333zm0-1.333h9.334v-8H3.333v8zM8 11.333c-.911 0-1.725-.247-2.442-.741A4.25 4.25 0 0 1 4 8.667a4.25 4.25 0 0 1 1.558-1.925C6.275 6.247 7.088 6 8 6c.911 0 1.725.247 2.442.742A4.25 4.25 0 0 1 12 8.667a4.25 4.25 0 0 1-1.558 1.925c-.717.494-1.53.741-2.442.741zm0-1c.622 0 1.189-.147 1.7-.441a3.14 3.14 0 0 0 1.2-1.225 3.14 3.14 0 0 0-1.2-1.225A3.344 3.344 0 0 0 8 7c-.622 0-1.189.147-1.7.442a3.14 3.14 0 0 0-1.2 1.225c.289.522.689.93 1.2 1.225a3.344 3.344 0 0 0 1.7.441zm0-.666a.964.964 0 0 0 .708-.292A.964.964 0 0 0 9 8.667a.964.964 0 0 0-.292-.709A.964.964 0 0 0 8 7.667a.964.964 0 0 0-.708.291.964.964 0 0 0-.292.709c0 .277.097.514.292.708.194.194.43.292.708.292z",
    fill: "#5F6368"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewLogo);
export default __webpack_public_path__ + "static/media/previewLogo.1b88b60107216bf243d31f99a5e6975f.svg";
export { ForwardRef as ReactComponent };